import { Component } from "react";
import { Link, LinkProps } from "react-router-dom";

import { Button, ButtonStyleProps } from "./button-style";

// TODO: Fix types
interface AnchorProps {
    href: string;
}

interface ButtonProps {
    type?: string;
    onClick?: () => void;
    inline?: boolean;
}

type Props = ButtonStyleProps & (AnchorProps | LinkProps | ButtonProps);

export default class extends Component<Props> {
    public static defaultProps = { variant: "primary" }; // TODO: Wait for TS 3.2 which fixes function components

    public render() {
        if ((this.props as AnchorProps).href !== undefined) {
            return <Button as="a" {...(this.props as any)} target="_blank" rel="noopener noreferrer" />;
        }

        if ((this.props as LinkProps).to !== undefined) {
            return <Button as={Link} {...(this.props as any)} />;
        }

        return <Button {...(this.props as any)} />;
    }
}
